import React from 'react';
import classNames from 'classnames';
import { Button, makeStyles, Typography } from "../../index";
import { ClearButton } from "./ClearButton";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        width: '100%',
        display: 'flex',
        position: 'relative',
    },
    buttonBase: {
        width: '100%',
        display: 'block',
        height: 40,
        borderWidth: theme.shape.borderWidth.normal,
        borderColor: theme.palette.text.hint,
        borderRadius: 8,
        transition: theme.transitions.create(['border-color', 'background-color', 'color'], {
            duration: theme.transitions.duration.shorter,
        }),
    },
    emptyButton: {
        borderColor: theme.palette.common.black,
        color: theme.palette.text.hint,
    },
    editButton: {
        padding: theme.spacing(0, 1),
        '&$clearable': { paddingRight: 40 },
        borderStyle: 'solid',
        borderColor: theme.palette.common.black,
        textAlign: 'left',
    },
    text: {
        width: '100%',
    },
    clearButton: {
        width: 40,
        height: 40 - theme.shape.borderWidth.normal * 2,
        position: 'absolute',
        top: theme.shape.borderWidth.normal,
        right: theme.shape.borderWidth.normal,
    },
    clearable: {},
}); });
export var FormButton = React.memo(function (props) {
    var _a;
    var isEmpty = props.isEmpty, clearable = props.clearable, value = props.value, placeholder = props.placeholder, onSelect = props.onSelect, onClear = props.onClear;
    var classes = useStyles();
    var emptyButtonClassName = classNames(classes.buttonBase, classes.emptyButton);
    var editButtonClassName = classNames(classes.buttonBase, classes.editButton, (_a = {},
        _a[classes.clearable] = clearable,
        _a));
    return (React.createElement("div", { className: classes.root }, isEmpty ? (React.createElement(Button, { className: emptyButtonClassName, onClick: onSelect },
        React.createElement(Typography, null, placeholder))) : (React.createElement(React.Fragment, null,
        React.createElement(Button, { className: editButtonClassName, onClick: onSelect },
            React.createElement(Typography, { variant: "body1", className: classes.text, noWrap: true }, value)),
        clearable && React.createElement(ClearButton, { className: classes.clearButton, onClick: onClear })))));
});
